export default {
  surchargeManagement: {
    title: 'Surcharge Maintenance',
    description: 'Manage various surcharge information',
    tabs: {
      fcl: 'FCL Surcharge',
      lcl: 'LCL Surcharge',
      air: 'Air Surcharge',
      rail: 'Rail Surcharge',
      prePort: 'Pre-port Surcharge',
      lastMile: 'Last Mile Surcharge',
      express: 'Express Surcharge'
    },
    rail: {
      filters: {
        code: 'Code',
        railCompany: 'Rail Company',
        supplier: 'Supplier',
        pol: 'Origin Station',
        pod: 'Destination Station',
        exitPort: 'Exit Port',
        entryPort: 'Entry Port',
        company: 'Company',
        cargoType: 'Cargo Type',
        validPeriod: 'Validity',
        status: 'Status'
      },
      placeholders: {
        batchCode: 'Batch search supported',
        select: 'Please select',
        selectRailCompany: 'Select rail company',
        selectSupplier: 'Select supplier',
        selectPol: 'Select origin station',
        selectPod: 'Select destination station',
        selectExitPort: 'Select exit port',
        selectEntryPort: 'Select entry port',
        selectCompany: 'Select company',
        selectCargoType: 'Select cargo type',
        selectStatus: 'Select status',
        startDate: 'Start date',
        endDate: 'End date',
        all: 'All'
      },
      actions: {
        search: 'Search',
        reset: 'Reset',
        add: 'New',
        import: 'Import',
        export: 'Export',
        batchEnable: 'Batch Enable',
        batchDisable: 'Batch Disable',
        view: 'Details',
        edit: 'Edit',
        copy: 'Copy',
        delete: 'Delete',
        more: 'More',
        enable: 'Enable',
        disable: 'Disable'
      },
      columns: {
        code: 'Code',
        priority: 'Priority',
        railCompany: 'Rail Company',
        supplier: 'Supplier',
        pol: 'Origin Station',
        pod: 'Destination Station',
        exitPort: 'Exit Port',
        entryPort: 'Entry Port',
        company: 'Company',
        cargoType: 'Cargo Type',
        feeItems: 'Fee Items',
        validPeriod: 'Validity',
        status: 'Status',
        actions: 'Actions'
      },
      status: {
        enabled: 'Enabled',
        disabled: 'Disabled',
        expired: 'Expired'
      },
      messages: {
        priorityTip: '1-99. Larger number means higher priority. Default is 1.',
        loadFailed: 'Failed to load rail surcharges',
        copied: 'Surcharge information copied. Confirm and save.',
        confirmActionTitle: 'Confirm {action}',
        confirmActionContent: 'Are you sure you want to {action} this surcharge?',
        actionSuccess: '{action} successfully',
        confirmDeleteTitle: 'Confirm Delete',
        confirmDeleteContent: 'This cannot be restored. Delete this surcharge?',
        deleteSuccess: 'Deleted successfully',
        selectSurcharge: 'Please select rail surcharges',
        batchEnableTitle: 'Batch Enable',
        batchDisableTitle: 'Batch Disable',
        batchEnableContent: 'Enable the selected {count} records?',
        batchDisableContent: 'Disable the selected {count} records?',
        batchEnableSuccess: 'Enabled {count} records',
        batchDisableSuccess: 'Disabled {count} records',
        feeItemCount: '{count} items',
        confirmExportTitle: 'Confirm Export',
        confirmExportSelected: 'Export the selected {count} rail surcharges. The task will run in the background and can be downloaded from Task Center.',
        confirmExportAll: 'Export rail surcharges by current filters. The task will run in the background and can be downloaded from Task Center.',
        exportSubmitFailed: 'Failed to submit export task',
        exportSubmitted: 'Export task submitted',
        exportFailed: 'Export failed',
        goTaskCenterTitle: 'Go to Task Center',
        goTaskCenterContent: 'Go to Task Center to view export progress?',
        goTaskCenterOk: 'Go to Task Center',
        confirm: 'Confirm',
        cancel: 'Cancel',
        dash: '-'
      },
      import: {
        title: 'Import Rail Surcharge',
        template: 'Template',
        downloadTemplate: 'Download Rail Surcharge Template',
        instructionTitle: 'Import Instructions',
        instruction1: '1. Supports .xlsx / .xls files up to 5MB.',
        instruction2: '2. Master data fields can use IDs, names, or codes that can be searched.',
        instruction3: '3. Multiple fee rows with the same matching fields will be merged into one rail surcharge.',
        instruction4: '4. Check Task Management for import results and failed row reasons.',
        uploadText: 'Click or drag file here',
        uploadHint: 'Supports .xlsx / .xls',
        reselect: 'Reselect',
        cancel: 'Cancel',
        startImport: 'Start Import',
        fileTypeError: 'Only .xlsx / .xls files are supported',
        fileSizeError: 'File size cannot exceed 5MB',
        downloadFailed: 'Failed to download template',
        taskCreated: 'Import task created. Check Task Management for results.',
        taskCreateFailed: 'Failed to create import task'
      },
      detail: {
        copyAlert: 'Copied surcharge information. Code will be regenerated. Confirm and save.',
        matchConditionTitle: 'Matching Conditions (Auto Match Rates)',
        matchConditionTip: 'When saving or editing a rate, the system automatically finds surcharge standards matching all conditions. Empty optional fields match all rates.',
        code: 'Code:',
        autoGenerate: 'Auto-generated',
        contractNo: 'Contract No.',
        validPeriod: 'Validity',
        startDate: 'Start Date',
        endDate: 'End Date',
        entryPort: 'Entry Port',
        originCity: 'Origin City',
        destinationCity: 'Destination City',
        originCountry: 'Origin Country',
        destinationCountry: 'Destination Country',
        containerOwner: 'Container Owner',
        directTransit: 'Direct/Transit',
        hsCode: 'HS Code',
        priority: 'Priority',
        feeDetailTitle: 'Fee Details',
        feeName: 'Fee Name',
        unit: 'Unit',
        currency: 'Currency',
        addFeeItem: 'Add Fee Item',
        createTitle: 'New Rail Surcharge',
        copyTitle: 'Copy Rail Surcharge',
        editTitle: 'Edit Rail Surcharge',
        viewTitle: 'Rail Surcharge Details',
        includeInTotal: 'Include in Total',
        alreadyIncluded: 'Already Included',
        paymentTerm: 'Payment Term',
        unitPrice: 'Unit Price',
        boxTypeSetting: 'Container Type Settings',
        boxTypeUpdated: 'Container type settings updated',
        unitRequired: 'Row {row}: please select unit',
        currencyRequired: 'Row {row}: please select currency',
        unitPriceRequired: 'Row {row}: please enter unit price',
        containerPriceRequired: 'Row {row}: when unit is container, enter at least one container type price',
        yes: 'Yes',
        no: 'No',
        prepaid: 'Prepaid',
        collect: 'Collect',
        prepaidCollect: 'Prepaid/Collect',
        input: 'Please enter',
        defaultPriority: 'Default 1',
        optionalMatchAll: 'Empty matches all',
        emptyMatchAll: 'Empty matches all',
        selectFeeName: 'Select fee name',
        keepOneFeeItem: 'At least one fee item is required',
        copied: 'Surcharge copied. Code will be regenerated.',
        requiredWarning: 'Please check required fields',
        companyRequired: 'Please select company',
        validPeriodRequired: 'Please select validity',
        railCompanyRequired: 'Please select rail company',
        exitPortRequired: 'Please select exit port',
        priorityRequired: 'Please enter priority',
        feeItemRequired: 'Please maintain at least one fee item',
        feeNameRequired: 'Please select fee name',
        updateSuccess: 'Surcharge updated successfully!',
        createSuccess: 'Surcharge created successfully!',
        saveFailed: 'Save failed, please retry',
        back: 'Back',
        save: 'Save'
      }
    },
    columns: {
      feeNo: 'Surcharge ID',
      feeStatus: 'Status',
      feeItems: 'Fee Items',
      pol: 'POL',
      pols: 'POL',
      polTerminalIds: 'POL Terminal',
      carrier: 'Carrier',
      carrierIds: 'Carrier',
      supplierIds: 'Supplier',
      pods: 'POD',
      podTerminalIds: 'POD Terminal',
      podRouteCategorys: 'POD Route Category',
      polRouteCategorys: 'POL Route Category',
      pors: 'POR',
      pdls: 'PDL',
      transferPorts: 'Transfer Port',
      officeIds: 'Office',
      contractNos: 'Contract No.',
      nacs: 'NAC',
      cargoTypes: 'Cargo Type',
      unitRate: 'Fee (BL)',
      lane: 'Route',
      validPeriod: 'Validity',
      createdBy: 'Created By',
      modifiedBy: 'Modified By',
      dateCreated: 'Created Time',
      dateModified: 'Modified Time',
      actions: 'Actions',
      chargingItems: 'Charge Items'
    },
    filterLabels: {
      feeNo: 'Fee ID',
      feeStatus: 'Status',
      portGroup: 'Port Group',
      pol: 'POL',
      carrier: 'Carrier',
      airline: 'Airline',
      lane: 'Route',
      validPeriod: 'Validity',
      beginDate: 'Start Date',
      endDate: 'End Date',
      createdBy: 'Created By',
      dateCreated: 'Created Time',
      modifiedBy: 'Modified By',
      dateModified: 'Modified Time'
    },
    statusEnum: {
      1: 'Disabled',
      2: 'Enabled',
      3: 'Expired',
      4: 'Disabled',
      6: 'Pending'
    },

    inquiryEnum: {
      1: 'Ocean Freight',
      2: 'Origin Charges',
      3: 'Destination Charges',
      4: 'Potential Charges'
    },
    fcl: {
      import: {
        title: 'Import FCL Surcharge',
        templateSection: 'Template Download',
        templateDesc: 'Download the template, fill in data according to the format, then upload',
        downloadTemplate: 'fcl-surcharge-import-template.xlsx',
        uploadSection: 'File Upload',
        dragText: 'Drag file here, or click to upload',
        dragHint: 'Supports .xlsx / .xls, max 5MB, multiple sheets allowed',
        remove: 'Remove',
        autoFillTitle: 'Auto-fill Instructions',
        autoFillOffice: 'Office: auto-filled from your current office on import',
        autoFillStatus: 'Status: determined by validity (current date ≤ end date → Enabled; otherwise → Expired)',
        autoFillUnit: 'Unit: supports Container, BL, Day, Time, KGS, CBM, TEN, RT',
        autoFillUnitSimple: 'Unit: supports Container, BL',
        autoFillBoxPrice: 'Container Price: at least one container type price required when unit is "Container"',
        autoFillUnitPrice: 'Unit Price: required when unit is not "Container"',
        autoFillInTotal: 'Count Into Total: defaults to "No"',
        autoFillIncluded: 'Total Included: defaults to "No"',
        cancel: 'Cancel',
        startValidate: 'Start Validation',
        validating: 'Validating...',
        fileSizeError: 'File size cannot exceed 5MB',
        fileTypeError: 'Please upload an Excel file (.xlsx or .xls)',
        uploadSuccess: 'Uploaded successfully, parse task submitted',
        uploadFailed: 'Upload failed, please try again',
        downloadSuccess: 'Template downloaded successfully',
        downloadFailed: 'Failed to download template'
      },

      title: 'FCL Surcharge Management',
      description: 'Manage FCL surcharge information',
      actions: {
        add: 'New FCL Surcharge',
        addOceanFreight: 'New Ocean Freight Surcharge',
        addPol: 'New POL Surcharge',
        addPod: 'New POD Surcharge',
        import: 'Import',
        batchOperations: 'Batch Operations',
        batchEnable: 'Batch Enable',
        batchDisable: 'Batch Disable',
        batchDelete: 'Batch Delete',
        view: 'Details',
        edit: 'Edit',
        more: 'More',
        copy: 'Copy',
        enable: 'Enable',
        disable: 'Disable',
        delete: 'Delete'
      },
      batch: {
        selected: 'Selected {count} items',
        enableConfirm: 'Enable {count} surcharges?',
        disableConfirm: 'Disable {count} surcharges?',
        deleteConfirm: 'Delete {count} surcharges? Cannot be undone.',
        enableSuccess: 'Enabled {count} surcharges',
        disableSuccess: 'Disabled {count} surcharges',
        deleteSuccess: 'Deleted {count} surcharges'
      },
      messages: {
        enableSuccess: 'Enable successful',
        enableFailed: 'Enable failed',
        disableSuccess: 'Disable successful',
        disableFailed: 'Disable failed',
        batchEnableSuccess: 'Batch enable successful',
        batchEnableFailed: 'Batch enable failed',
        batchDisableSuccess: 'Batch disable successful',
        batchDisableFailed: 'Batch disable failed',
        deleteSuccess: 'Delete successful',
        deleteFailed: 'Delete failed',
        statusSwitchFailed: 'Status toggle failed',
        onlyDraftCanEnable: 'Only Draft can be online. Selection: {status}',
        exportFilename: 'FCL Surcharge Export.xlsx',
        exportFilenamePrefix: 'FCL Surcharge Export',
        exportSuccess: 'Export successful',
        exportFailed: 'Export failed',
        onlyNormalCanDisable: 'Only Normal can be offline. Selection: {status}',
        importFeature: 'Importing under development',
        aiRecognitionDemo: 'AI Recognition Demo',
        missingRecordId: 'View failed: missing ID',
        missingEditId: 'Edit failed: missing ID',
        loadDataFailed: 'Load data failed',
        statusOperationNotAllowed: 'Surcharge in {status} status cannot be enabled/disabled',
        copyDataFailed: 'Copy failed',
        draftSaveSuccess: 'Draft saved',
        draftSaveFailed: 'Draft save failed',
        unknown: 'Unknown error',
        noBaseFeeData: 'No basic fee data',
        saveDataFirst: 'Save data first',
        atLeastOneRateItem: 'At least one item required',
        containerSettingsUpdated: 'Box settings updated',
        aiRecognitionSuccess: 'AI recognition completed! Rate info auto-filled.',
        atLeastOneContainerType: 'Unit is "Container": at least one container type price required (row {row})',
        unitRateRequired: 'Unit is "BL": unit price is required (row {row})',
        billingUnitRequired: 'Billing unit is required (row {row})',
        currencyRequired: 'Currency is required (row {row})',
        isTotalIncludedRequired: '"Is total included" is required (row {row})',
        isCountTotalRequired: '"Count into total" is required (row {row})',
        feeItemRequired: 'Fee name is required (row {row})',
        conflictTitle: 'Validity Conflict',
        conflictTip: 'Validity conflict with {feeNos}. Confirm override and save?',
        confirmOverride: 'Confirm Override'
      },
      detail: {
        createTitle: 'New FCL Surcharge',
        editTitle: 'Edit FCL Surcharge',
        viewTitle: 'Surcharge Detail',
        copyTitle: 'Copy FCL Surcharge',
        createTitleOceanFreight: 'New Ocean Freight Surcharge',
        editTitleOceanFreight: 'Edit Ocean Freight Surcharge',
        viewTitleOceanFreight: 'Ocean Freight Surcharge Detail',
        copyTitleOceanFreight: 'Copy Ocean Freight Surcharge',
        createTitleOceanFreightLcl: 'New LCL Ocean Surcharge',
        editTitleOceanFreightLcl: 'Edit LCL Ocean Surcharge',
        viewTitleOceanFreightLcl: 'LCL Ocean Surcharge Details',
        copyTitleOceanFreightLcl: 'Copy LCL Ocean Surcharge',
        createTitleAir: 'New Air Surcharge',
        editTitleAir: 'Edit Air Surcharge',
        viewTitleAir: 'Air Surcharge Detail',
        copyTitleAir: 'Copy Air Surcharge',
        createTitlePol: 'New POL Surcharge',
        editTitlePol: 'Edit POL Surcharge',
        viewTitlePol: 'POL Surcharge Detail',
        copyTitlePol: 'Copy POL Surcharge',
        createTitlePolLcl: 'New LCL Origin Surcharge',
        editTitlePolLcl: 'Edit LCL Origin Surcharge',
        viewTitlePolLcl: 'LCL Origin Surcharge Details',
        copyTitlePolLcl: 'Copy LCL Origin Surcharge',
        createTitlePod: 'New POD Surcharge',
        editTitlePod: 'Edit POD Surcharge',
        viewTitlePod: 'POD Surcharge Detail',
        copyTitlePod: 'Copy POD Surcharge',
        createTitlePodLcl: 'New LCL Destination Surcharge',
        editTitlePodLcl: 'Edit LCL Destination Surcharge',
        viewTitlePodLcl: 'LCL Destination Surcharge Details',
        copyTitlePodLcl: 'Copy LCL Destination Surcharge',
        basicInfo: 'Basic Information',
        pol: 'POL',
        polTerminal: 'POL Terminal',
        carrier: 'Carrier',
        feeStatus: 'Status',
        lane: 'Route',
        validPeriod: 'Validity',
        beginDate: 'Start Date',
        endDate: 'End Date',
        supplier: 'Supplier',
        pod: 'POD',
        podTerminal: 'POD Terminal',
        podRouteCategory: 'POD Route Category',
        polRouteCategory: 'POL Route Category',
        pors: 'POR',
        pdls: 'PDL',
        transferPorts: 'Transfer Port',
        office: 'Office',
        contractNo: 'Contract No.',
        cargoType: 'Cargo Type',
        priority: 'Priority',
        priorityTooltip: 'Higher value = higher priority',
        yes: 'Yes',
        no: 'No',
        paymentTypes: {
          prepaid: 'Prepaid',
          collect: 'Collect',
          prepaidOrCollect: 'Prepaid/Collect'
        },
        priceDetails: 'Rate Details',
        feeDetails: 'Fee Details',
        feeDetailsTipPol: 'Duplicate fee names are not allowed within the same record; Price is required when unit is Ticket, and container price is required when unit is Container',
        feeDetailsTipPod: 'Price (Ticket) is required when unit is Ticket; Container prices are required when unit is Container (supports dynamic container types)',
        byContainerType: 'Box-based',
        notByContainerType: 'Non-box-based',
        containerTypeSettings: 'Box Settings',
        selectContainerTypes: 'Select the container types to display',
        addItem: 'Add Item',
        baseFee: 'Basic Fee',
        feeItem: 'Fee Name',
        autoFill: 'Auto fill',
        billingUnit: 'Unit',
        unitPrice: 'Unit Price',
        specialRemarks: 'Special Note',

        // Table Columns
        tableColumns: {
          feeName: 'Fee Name',
          billingType: 'Billing Type',
          currency: 'Currency',
          billingUnit: 'Unit',
          unitPrice: 'Unit Price',
          unitRate: 'Unit Price',
          specialRemarks: 'Special Note',
          actions: 'Actions',
          baseFee: 'Basic Fee',
          isTotalIncluded: 'Total Included',
          isCountTotal: 'Count Into Total',
          paymentType: 'Payment Term'
        },

        operationButtons: {
          addItem: 'Add Item',
          delete: 'Delete'
        },
        billingTypes: {
          byContainerType: 'Box-based',
          notByContainerType: 'Non-box-based'
        },
        aiRecognition: 'AI Recognition',
        uploadFile: 'Upload File',
        dragAndDrop: 'Click or drag file here to upload',
        supportedFormats: 'Formats: PDF, Excel, Word, Image etc.',
        selectFile: 'Select File',
        aiDescription: 'AI Recognition Info',
        aiFeatures: [
          '• AI will automatically recognize ports, carriers, prices etc.',
          '• Supports multiple formats and complex table structures',
          '• Info will be auto-filled after identification',
          '• Please ensure uploaded files are clear and readable'
        ],
        copyTip: 'Copying info. Rate No. will be regenerated. Confirm and save.',
        placeholders: {
          selectPol: 'Select POL',
          selectPolTerminal: 'Select POL Terminal',
          selectCarrier: 'Select carrier',
          selectFeeStatus: 'Select status',
          selectPortGroup: 'Select port group',
          selectLane: 'Select route',
          selectFeeItem: 'Select fee name',
          selectBillingType: 'Select billing type',
          selectBillingUnit: 'Select unit',
          enterPrice: 'Enter price',
          enterUnitPrice: 'Enter unit price',
          enterRemarks: 'Enter note',
          feeNoGenerated: 'Auto generated, e.g. 73F75AN6',
          feeNoCopy: 'Regenerated after copying, e.g. 73F75AN6',
          selectSupplier: 'Select supplier',
          selectPod: 'Select POD',
          selectPodTerminal: 'Select POD Terminal',
          selectPodRouteCategory: 'Select POD route category',
          selectPolRouteCategory: 'Select POL route category',
          selectPors: 'Select POR',
          selectPdls: 'Select PDL',
          selectTransferPorts: 'Select transfer port',
          selectOffice: 'Select office',
          selectContractNo: 'Select contract no.',
          selectNac: 'Select NAC',
          selectCargoType: 'Select cargo type',
          enterPriority: 'Enter priority',
          selectCurrency: 'Select currency',
          selectPaymentType: 'Select payment type',
          enterFeeNo: 'Enter fee ID',
          enterCreatedBy: 'Enter creator',
          enterModifiedBy: 'Enter modifier',
          selectBeginDate: 'Select start date',
          selectEndDate: 'Select end date',
          selectDateCreated: 'Select creation time',
          selectDateModified: 'Select modification time'
        },
        validation: {
          selectPolRequired: 'Select POL',
          selectPodRequired: 'Select POD',
          selectCarrierRequired: 'Select carrier',
          selectFeeStatusRequired: 'Select status',
          selectLaneRequired: 'Select at least one route',
          selectValidPeriodRequired: 'Select validity',
          selectFeeItemRequired: 'Select fee name',
          selectBillingUnitRequired: 'Select unit',
          enterPriceRequired: 'Enter price',
          enterUnitPriceRequired: 'Enter unit price',
          selectPodRouteCategoryRequired: 'Select POD route category',
          selectOfficeRequired: 'Select office'
        },
        status: {
          normal: 'Normal',
          disabled: 'Disabled'
        },
        buttons: {
          back: 'Back',
          save: 'Save',
          edit: 'Edit',
          copy: 'Copy'
        },
        messages: {
          containerSettingsUpdated: 'Box settings updated',
          atLeastOneRateItem: 'At least one item required',
          aiRecognitionSuccess: 'AI recognition completed! Rate info auto-filled.'
        }
      }
    },

    lcl: {
      import: {
        title: 'Import LCL Ocean Surcharge',
        templateSection: 'Template Download',
        templateDesc: 'Download the standard import template first, fill in data per the template, then upload',
        oceanTemplate: 'Ocean Surcharge Template',
        polTemplate: 'POL Surcharge Template',
        podTemplate: 'POD Surcharge Template',
        uploadSection: 'File Upload',
        dragText: 'Drag file here, or click to upload',
        dragHint: 'Supports .xlsx / .xls, max 5MB, multiple Sheets allowed',
        remove: 'Remove',
        autoFillTitle: 'Auto-fill Notes',
        autoFillOffice: 'Office: auto-filled with your office on import',
        autoFillStatus: 'Status: auto-calculated from validity (current date ≤ end date → Enabled; else → Expired)',
        autoFillUnit: 'Billing Unit: supports Container, Ticket, Day, Time, Weight (KGS), Volume (CBM), Ton (TEN), Revenue Ton (RT)',
        autoFillBoxPrice: 'Container Price: price required for any container type when unit is "Container"',
        autoFillUnitPrice: 'Unit Price: required when unit is not "Container"',
        autoFillInTotal: 'Count into Total: defaults to "No"',
        autoFillIncluded: 'Total Included: defaults to "No"',
        cancel: 'Cancel',
        startValidate: 'Start Validation',
        validating: 'Validating...',
        validatePass: 'Validation Passed',
        validatePassDesc: 'Parsed {success} surcharge records containing {detail} fee items',
        validatePassSummary: 'Ocean Surcharge: {ocean} | POL Surcharge: {pol} | POD Surcharge: {pod}',
        previewTitle: 'Data Preview (First 10)',
        colFeeType: 'Fee Type',
        colCarrier: 'Carrier',
        colPort: 'Port',
        colFeeCount: 'Fee Items',
        colFeeCountSuffix: '{count} items',
        colValidity: 'Validity',
        validateFail: 'Validation complete, {fail} error(s) found',
        validateFailDesc: 'Success: {success}  |  Failed: {fail}',
        errorTitle: 'Error Details',
        colSheet: 'Sheet',
        colRowNo: 'Row',
        colFieldName: 'Field',
        colErrorMsg: 'Error',
        downloadError: 'Download Error Report',
        successPreviewTitle: 'Success Preview ({count} records)',
        back: 'Back to Edit',
        confirmImport: 'Confirm Import ({count} records)',
        importing: 'Importing...',
        importedProgress: 'Processed: {processed} / {total}',
        importSuccess: 'Import Successful',
        importSuccessDesc: 'Successfully imported {success} surcharge records containing {detail} fee items',
        importPartial: 'Import Complete, Partial Success',
        importPartialDesc: 'Imported {success}, failed {fail}',
        importPartialHint: 'Error details exported to error report. Fix and re-import.',
        confirm: 'OK',
        fileSizeError: 'File size cannot exceed 5MB',
        fileTypeError: 'Please upload an Excel file (.xlsx or .xls)',
        uploadSuccess: 'Uploaded successfully, parsing task submitted',
        uploadFailed: 'Upload failed, please retry',
        downloadSuccess: 'Template downloaded',
        downloadFailed: 'Template download failed',
        generatingReport: 'Generating error report Excel...'
      }
    },

    air: {
      actions: {
        add: 'New Air Surcharge'
      },
      detail: {
        // Page titles
        createTitle: 'New Air Surcharge',
        editTitle: 'Edit Air Surcharge',
        viewTitle: 'Air Surcharge Detail',
        copyTitle: 'Copy Air Surcharge',

        // Form field labels
        airline: 'Airline (Multiple)',
        dateType: 'Date Type',
        originSection: 'Origin (Country - City - Airport)',
        originCountry: 'Origin Country (Multiple)',
        originCity: 'Origin City (Multiple)',
        originAirport: 'Origin Airport (Multiple, Highest Priority)',
        destSection: 'Destination (Country - City - Airport)',
        destCountry: 'Dest Country (Multiple)',
        destCity: 'Dest City (Multiple)',
        destAirport: 'Dest Airport (Multiple, Highest Priority)',
        iataZone: 'IATA Zone (Fallback)',
        contractNacSection: 'Contract No. & NAC',
        nac: 'NAC (Multiple)',
        feeStatus: 'Status',
        feeStatusAutoCalc: 'Auto-calculated from validity and enable status',
        priority: 'Priority',
        priorityTooltip: 'Higher value = higher priority',

        // Status enum
        statusEnum: {
          enabled: 'Enabled',
          disabled: 'Disabled',
          expired: 'Expired'
        },

        // Date type options
        dateTypeOptions: {
          flightDate: 'Flight Date (e.g. FSC)',
          billDate: 'Bill Date (e.g. AWC)'
        },

        // IATA zone options
        iataZoneOptions: {
          tc1: 'TC1 - Americas',
          tc2: 'TC2 - Europe/Africa',
          tc3: 'TC3 - Asia Pacific'
        },

        // Fee category options
        feeCategoryOptions: {
          origin: 'Origin Charges',
          dest: 'Destination Charges',
          mainline: 'Mainline Surcharge'
        },

        // Charge method options
        chargeMethodOptions: {
          byBl: 'Per BL',
          byChargeWeight: 'Chargeable Weight (/KG)',
          byActualWeight: 'Actual Weight (/KG)'
        },

        // Payment terms options
        paymentTermsOptions: {
          prepaid: 'Prepaid',
          collect: 'Collect'
        },

        // Placeholders
        placeholders: {
          matchAll: 'Empty = match all',
          unitRate: 'Unit Rate',
          minCharge: 'Min Charge',
          maxCharge: 'Max Charge',
          remarks: 'Remarks',
          enterPriority: 'Enter priority'
        },

        // Table columns
        tableColumns: {
          chargeName: 'Fee Name',
          chargeNameEn: 'English Name',
          feeCategory: 'Fee Category',
          paymentTerms: 'Payment Terms',
          currency: 'Currency',
          chargeMethod: 'Charge Method',
          unitRate: 'Unit Rate',
          minCharge: 'Min Charge',
          maxCharge: 'Max Charge',
          includeInTotal: 'Count in Total',
          alreadyIncluded: 'Total Included',
          remarks: 'Remarks',
          actions: 'Actions'
        },

        // Buttons
        buttons: {
          back: 'Back',
          save: 'Save',
          edit: 'Edit',
          copy: 'Copy'
        },

        // Messages
        messages: {
          copiedSuccess: 'Copied to form. Save to apply.',
          loadFailed: 'Load data failed',
          copyLoadFailed: 'Copy data load failed',
          fillRequiredFields: 'Please complete required basic info',
          fillChargeName: 'Row {row}: fee name is required',
          fillFeeCategory: 'Row {row}: fee category is required',
          fillPaymentTerms: 'Row {row}: payment terms is required',
          fillCurrency: 'Row {row}: currency is required',
          fillChargeMethod: 'Row {row}: charge method is required',
          fillUnitRate: 'Row {row}: unit rate is required',
          updateSuccess: 'Updated successfully',
          saveSuccess: 'Saved successfully',
          saveFailed: 'Save failed',
          atLeastOneFeeItem: 'At least one fee item required',
          countSuffix: 'items',
          conflictTitle: 'Validity Conflict',
          conflictTip: 'Validity conflict with {feeNos}. Confirm override and save?',
          confirmOverride: 'Confirm Override'
        },

        // Validation
        validation: {
          dateTypeRequired: 'Please select date type'
        }
      },

      import: {
        title: 'Import Air Surcharge',
        templateSection: 'Template Download',
        templateDesc: 'Download the standard import template first, fill in data per the template, then upload',
        templateFile: 'Air Surcharge Import Template.xlsx',
        uploadSection: 'File Upload',
        dragText: 'Drag file here, or click to upload',
        dragHint: 'Supports .xlsx / .xls, max 5MB',
        remove: 'Remove',
        autoFillTitle: 'Auto-fill Notes',
        autoFillOffice: 'Office: auto-filled with your office on import',
        autoFillCode: 'Code: auto-generated by system (format: AIR-YYYYNNNN)',
        autoFillStatus: 'Status: auto-calculated from validity (current date ≤ end date → Enabled; else → Expired)',
        autoFillChargeMethod: 'Charge Method: By Weight / Actual Weight / Per BL',
        autoFillCountTotal: 'Count into Total: defaults to "No"',
        autoFillTotalIncluded: 'Total Included: defaults to "No"',
        fieldTitle: 'Field Notes',
        fieldOptional: 'Airline / Origin Country / City / Airport / Dest Country / City / Airport / Supplier / Contract No. / NAC: optional, supports multiple (semicolon-separated); empty = match all',
        fieldNacNote: 'Contract No. & NAC: bidirectionally linked, recommend filling only one',
        fieldLinkage: 'Origin Country/City/Airport & Dest Country/City/Airport: cascaded filtering',
        fieldDateRequired: 'Date Type / Validity: required',
        fieldFeeRequired: 'Fee Name / Fee Category / Payment Terms / Currency / Charge Method / Unit Rate / Count into Total / Total Included: required',
        cancel: 'Cancel',
        startValidate: 'Start Validation',
        validating: 'Validating...',
        validatePass: 'Validation Passed',
        validatePassDesc: 'Parsed {success} surcharge records containing {detail} fee items',
        previewTitle: 'Data Preview (First 10)',
        validateFail: 'Validation complete, {fail} error(s) found',
        validateFailDesc: 'Success: {success}  |  Failed: {fail}',
        errorTitle: 'Error Details',
        downloadError: 'Download Error Report',
        successPreviewTitle: 'Success Preview ({count} records)',
        colAirline: 'Airline',
        colPolAirport: 'Origin Airport',
        colPodAirport: 'Dest Airport',
        colIataZone: 'IATA Zone',
        colContractNo: 'Contract No.',
        colFeeCount: 'Fee Items',
        colFeeCountSuffix: ' items',
        colValidity: 'Validity',
        colRowNo: 'Row',
        colFieldName: 'Field',
        colErrorMsg: 'Error',
        back: 'Back to Edit',
        confirmImport: 'Confirm Import ({count} records)',
        importing: 'Importing...',
        importedProgress: 'Processed: {processed} / {total}',
        importSuccess: 'Import Successful',
        importSuccessDesc: 'Successfully imported {success} surcharge records containing {detail} fee items',
        importPartial: 'Import Complete, Partial Success',
        importPartialDesc: 'Imported {success}, failed {fail}',
        importPartialHint: 'Error details exported to error report. Fix and re-import.',
        confirm: 'OK',
        fileSizeError: 'File size cannot exceed 5MB',
        fileTypeError: 'Please upload an Excel file (.xlsx or .xls)',
        uploadSuccess: 'Uploaded successfully, parsing task submitted',
        uploadFailed: 'Upload failed, please retry',
        downloadSuccess: 'Template downloaded',
        generatingReport: 'Generating error report Excel...'
      }
    },

    prePort: {
      import: {
        title: 'Import Pre-port Surcharge',
        templateSection: 'Template Download',
        templateDesc: 'Download the template, fill in data according to the format, then upload',
        downloadTemplate: 'pre-port-surcharge-import-template.xlsx',
        uploadSection: 'File Upload',
        dragText: 'Drag file here, or click to upload',
        dragHint: 'Supports .xlsx / .xls, max 5MB',
        remove: 'Remove',
        autoFillTitle: 'Auto-fill Instructions',
        autoFillOffice: 'Office: auto-filled from your current office on import',
        autoFillStatus: 'Status: determined by validity (current date ≤ end date → Enabled; otherwise → Expired)',
        autoFillUnit: 'Unit: supports Container, BL, Day, Time, KGS, CBM, TEN, RT',
        autoFillBoxPrice: 'Container Price: at least one container type price required when unit is "Container"',
        autoFillUnitPrice: 'Unit Price: required when unit is not "Container"',
        autoFillInTotal: 'Count Into Total: defaults to "No"',
        autoFillIncluded: 'Total Included: defaults to "No"',
        cancel: 'Cancel',
        startValidate: 'Start Validation',
        validating: 'Validating...',
        fileSizeError: 'File size cannot exceed 5MB',
        fileTypeError: 'Please upload an Excel file (.xlsx or .xls)',
        uploadSuccess: 'Uploaded successfully, parse task submitted',
        uploadFailed: 'Upload failed, please try again',
        downloadSuccess: 'Template downloaded successfully',
        downloadFailed: 'Failed to download template'
      },
      columns: {
        rateType: 'Rate Type',
        feederType: 'Feeder Type',
        railSeaType: 'Rail-Sea Type',
        pol: 'POL',
        polTerminal: 'POL Terminal',
        supplier: 'Supplier',
        airPort: 'Origin Airport',
        priority: 'Priority'
      },
      configName: 'Pre-port Surcharge',
      actions: {
        add: 'New Pre-port Surcharge',
        import: 'Import',
        batchEnable: 'Batch Enable ({count})',
        batchDisable: 'Batch Disable ({count})',
        view: 'Details',
        edit: 'Edit',
        more: 'More',
        copy: 'Copy',
        enable: 'Enable',
        disable: 'Disable',
        delete: 'Delete'
      },
      messages: {
        deleteTitle: 'Confirm Delete',
        deleteContent: 'Are you sure you want to delete this record? This cannot be undone.',
        deleteOkText: 'Confirm Delete',
        disableContent: 'Are you sure you want to disable this record?',
        enableContent: 'Are you sure you want to enable this record?',
        batchEnableTitle: 'Batch Enable',
        batchEnableContent: 'Enable {count} selected record(s)?',
        batchDisableTitle: 'Batch Disable',
        batchDisableContent: 'Disable {count} selected record(s)?',
        enableSuccess: 'Enabled successfully',
        enableFailed: 'Enable failed',
        disableSuccess: 'Disabled successfully',
        disableFailed: 'Disable failed',
        deleteSuccess: 'Deleted successfully',
        deleteFailed: 'Delete failed',
        batchEnableSuccess: 'Successfully enabled {count} records',
        batchEnableFailed: 'Batch enable failed',
        batchDisableSuccess: 'Successfully disabled {count} records',
        batchDisableFailed: 'Batch disable failed',
        dateRangeTo: 'Until {date}',
        dateRangeFrom: 'From {date}'
      },
      detail: {
        createTitle: 'New Pre-port Surcharge',
        editTitle: 'Edit Pre-port Surcharge',
        viewTitle: 'Pre-port Surcharge Detail',
        copyTitle: 'Copy Pre-port Surcharge',
        copyModeAlert: 'Copy mode: original surcharge data copied. ID will be auto-generated after saving.',
        basicInfo: 'Basic Information',
        feeNo: 'Surcharge No.',
        rateType: 'Rate Type',
        feederType: 'Feeder Type',
        railSeaType: 'Rail-Sea Type',
        pol: 'POL',
        polTerminal: 'POL Terminal',
        supplier: 'Supplier',
        cargoType: 'Cargo Type',
        airPort: 'Origin Airport',
        office: 'Office',
        priority: 'Priority',
        priorityTooltip: 'Higher value = higher priority',
        validPeriod: 'Validity',
        originRegion: 'Origin Region',
        regionTip1: 'Origin region is used to match cargo pickup address. Supports province/city/district/township/community selection.',
        regionTip2: 'If left empty, applies to all regions. More specific entries have higher match priority.',
        originLabel: 'Origin {n}',
        noRegionSelected: 'No region selected',
        province: 'Province',
        city: 'City',
        district: 'District',
        township: 'Township',
        community: 'Community',
        administrativeDivision: 'Administrative Division',
        detailLocation: 'Specific Location',
        detailAddress: 'Detail Address',
        addOriginAddress: 'Add Origin Address',
        feeDetails: 'Fee Details',
        containerTypeSettings: 'Box Type Settings',
        addFeeItem: 'Add Fee Item',
        selectBoxTypeTip: 'Select container types to display:',
        delete: 'Delete',
        yes: 'Yes',
        no: 'No',
        buttons: {
          back: 'Back',
          save: 'Save',
          edit: 'Edit',
          copy: 'Copy'
        },
        placeholders: {
          feeNoGenerated: 'Auto-generated after saving',
          feeNoAuto: 'Auto-generated',
          select: 'Please select',
          enterPriority: 'Enter priority',
          beginDate: 'Start Date',
          endDate: 'End Date',
          selectProvince: 'Select Province',
          selectCity: 'Select City',
          selectDistrict: 'Select District',
          selectTownship: 'Select Township',
          selectCommunity: 'Select Community',
          enterDetailAddress: 'Enter detail address and press Enter to confirm',
          selectFeeItem: 'Select fee name',
          enterUnitPrice: 'Enter unit price',
          enterUnitRate: 'Enter fee (BL)',
          enterRemarks: 'Enter remarks',
          enterInput: 'Enter'
        },
        validation: {
          rateTypeRequired: 'Please select rate type',
          feederTypeRequired: 'Please select feeder type',
          railSeaTypeRequired: 'Please select rail-sea type',
          officeIdsRequired: 'Please select office',
          provinceIdRequired: 'Please select province',
          cityIdRequired: 'Please select city'
        },
        tableColumns: {
          feeName: 'Fee Name',
          billingUnit: 'Billing Unit',
          currency: 'Currency',
          unitPrice: 'Unit Price',
          unitRate: 'Fee (BL)',
          paymentType: 'Payment Type',
          remarks: 'Remarks',
          isTotalIncluded: 'Total Included',
          isCountTotal: 'Count Into Total',
          actions: 'Actions'
        },
        messages: {
          pleaseFillRequired: 'Please complete all required fields',
          feeNameRequired: 'Row {row}: fee name is required',
          billingUnitRequired: 'Row {row}: billing unit is required',
          currencyRequired: 'Row {row}: currency is required',
          isTotalIncludedRequired: 'Row {row}: please select whether total is included',
          isCountTotalRequired: 'Row {row}: please select whether to count into total',
          conflictTitle: 'Data Conflict',
          conflictContent: 'Conflict with surcharges: {feeNos}. Continue saving?',
          confirmOverride: 'Confirm Override',
          cancel: 'Cancel',
          saveSuccess: 'Saved successfully',
          saveFailed: 'Save failed'
        }
      }
    },

    express: {
      configName: 'Express Surcharge',
      actions: {
        add: 'New Express Surcharge',
        batchEnable: 'Batch Enable ({count})',
        batchDisable: 'Batch Disable ({count})',
        view: 'Details',
        edit: 'Edit',
        more: 'More',
        copy: 'Copy',
        enable: 'Enable',
        disable: 'Disable',
        delete: 'Delete',
        addFeeItem: 'Add Fee Item'
      },
      changeHistory: {
        title: 'Change History',
        titleWithCode: '{code} Change History',
        dateCreated: 'Change Time',
        createdBy: 'Operator',
        operationType: 'Operation',
        changedField: 'Field',
        oldValue: 'Before',
        newValue: 'After',
        allOperationTypes: 'All Operation Types',
        operatorFilter: 'Filter by Operator',
        empty: 'No change history',
        recordMeta: 'Surcharge Type: {type} · Code: {code}',
        expandChanges: 'Show Changed Fields',
        collapseChanges: 'Hide Changed Fields',
        beginDate: 'Valid From',
        endDate: 'Valid To',
        originDistrict: 'Origin District',
        originDetailAddress: 'Origin Detail Address',
        destDistrict: 'Destination District',
        destDetailAddress: 'Destination Detail Address',
        feeItems: 'Fee Items',
        feeItemChange: 'Fee Item Change: {name}',
        feeItemChangePrefix: 'Fee Item Change: ',
        feeItemFieldChange: 'Fee Item {name} · {field}',
        operations: {
          create: 'Create',
          update: 'Edit',
          delete: 'Delete',
          statusChange: 'Status Change',
          enable: 'Enable',
          disable: 'Disable'
        },
        status: {
          enabled: 'Enabled',
          disabled: 'Disabled',
          expired: 'Expired'
        }
      },
      columns: {
        feeNo: 'Surcharge Code',
        route: 'Route'
      },
      sections: {
        basicInfo: 'Basic Information',
        routeInfo: 'Route Information',
        feeDetails: 'Fee Details'
      },
      fields: {
        feeNo: 'Surcharge No.',
        priority: 'Priority',
        priorityTip: 'Higher value has higher matching priority. Default is 50.',
        unlimited: 'Unrestricted',
        supplier: 'Express Carrier',
        accountNo: 'Account No.',
        serviceType: 'Service Type',
        officeIds: 'Office',
        logisticsSupplierIds: 'Supplier',
        contractNos: 'Contract No.',
        cargoTypes: 'Cargo Type',
        validPeriod: 'Validity',
        feeStatus: 'Status',
        origin: 'Origin',
        destination: 'Destination',
        originRoute: 'Origin',
        destRoute: 'Destination',
        originCountry: 'Origin Country',
        originProvince: 'Origin Province/State',
        originCity: 'Origin City',
        destCountry: 'Destination Country',
        destProvince: 'Destination Province/State',
        destCity: 'Destination City',
        country: 'Country',
        province: 'Province/State',
        city: 'City',
        district: 'District',
        detailAddress: 'Detail Address',
        firstWeightThreshold: 'First Weight Threshold',
        firstWeightPrice: 'First Weight Price',
        additionalWeightUnit: 'Additional Weight Unit',
        additionalWeightPrice: 'Additional Weight Price',
        unitPrice: 'Unit Price',
        fixedAmount: 'Fixed Amount',
        minCharge: 'Minimum Charge'
      },
      billingMode: {
        firstAdditional: 'First + Additional',
        unitPrice: 'Unit Price',
        fixed: 'Fixed Fee',
        percentage: 'Percentage'
      },
      tableColumns: {
        chargeItem: 'Fee Name',
        billingMode: 'Billing Mode',
        billingParams: 'Billing Params',
        measure: 'Unit',
        currency: 'Currency',
        minCharge: 'Minimum Charge',
        paymentType: 'Payment Term',
        includeInTotal: 'Count Into Total',
        alreadyIncluded: 'Included',
        remarks: 'Remarks',
        actions: 'Actions'
      },
      enums: {
        boolean: {
          yes: 'Yes',
          no: 'No'
        }
      },
      placeholders: {
        feeNoGenerated: 'Auto-generated after saving',
        priority: 'Enter 1-99',
        supplier: 'Select express carrier',
        accountNo: 'Select or enter account no.',
        serviceType: 'Select service type',
        officeIds: 'Select office',
        matchAll: 'Empty = match all',
        beginDate: 'Start Date',
        endDate: 'End Date',
        detailAddress: 'Enter detail address',
        chargeItem: 'Select fee name',
        billingMode: 'Select billing mode',
        measure: 'Select unit',
        currency: 'Select currency',
        paymentType: 'Select payment term',
        remarks: 'Enter remarks'
      },
      validation: {
        priorityRequired: 'Please enter priority',
        priorityRange: 'Priority must be between 1 and 99',
        matchFieldRequired: 'Enter {field}, or select "Unrestricted"',
        officeIdsRequired: 'Please select office',
        unsupportedServiceType: 'The service type is not configured for the selected express carrier',
        chargeItemRequired: 'Row {row}: fee name is required',
        billingModeRequired: 'Row {row}: billing mode is required',
        measureRequired: 'Row {row}: unit is required',
        currencyRequired: 'Row {row}: currency is required',
        paymentTypeRequired: 'Row {row}: payment term is required',
        firstAdditionalRequired: 'Row {row}: first and additional weight parameters are required',
        unitPriceRequired: 'Row {row}: unit price, fixed amount, or percentage is required',
        percentageInvalid: 'Row {row}: only fuel surcharge can use a percentage between 0 and 100'
      },
      messages: {
        loadDataFailed: 'Load data failed',
        missingRecordId: 'Missing record ID',
        deleteTitle: 'Confirm Delete',
        deleteContent: 'Are you sure you want to delete this record? This cannot be undone.',
        deleteOkText: 'Confirm Delete',
        deleteSuccess: 'Deleted successfully',
        deleteFailed: 'Delete failed',
        disableContent: 'Are you sure you want to disable this record?',
        enableContent: 'Are you sure you want to enable this record?',
        enableSuccess: 'Enabled successfully',
        enableFailed: 'Enable failed',
        disableSuccess: 'Disabled successfully',
        disableFailed: 'Disable failed',
        batchEnableTitle: 'Batch Enable',
        batchEnableContent: 'Enable {count} selected record(s)?',
        batchDisableTitle: 'Batch Disable',
        batchDisableContent: 'Disable {count} selected record(s)?',
        batchEnableSuccess: 'Successfully enabled {count} records',
        batchEnableFailed: 'Batch enable failed',
        batchDisableSuccess: 'Successfully disabled {count} records',
        batchDisableFailed: 'Batch disable failed',
        matchAll: 'All',
        dateRangeTo: 'Until {date}',
        dateRangeFrom: 'From {date}',
        atLeastOneFeeItem: 'At least one fee item is required',
        pleaseFillRequired: 'Please complete required fields',
        conflictTitle: 'Data Conflict',
        conflictContent: 'Conflicting surcharges exist: {feeNos}. Please adjust before saving or enabling.',
        updateSuccess: 'Updated successfully',
        saveSuccess: 'Saved successfully',
        saveFailed: 'Save failed',
        copyDataFailed: 'Failed to load copied data',
        loadChangeLogFailed: 'Failed to load change history',
        validityConflictTitle: 'Confirm Validity Conflict Resolution',
        validityConflictHint: 'Confirmation updates the existing records below, affecting all their fee items and applicable scopes. Turning off the switch will not restore these changes.',
        validityCurrentPeriod: 'New record validity: {period}',
        validityExistingPeriod: 'Existing record validity: {period}',
        validityDisable: 'The existing surcharge will be disabled for its entire validity period.',
        validityTruncate: 'The existing surcharge expiry date will be changed to {date}.',
        validityConfirm: 'Confirm and Apply',
        validityUnlimited: 'Unrestricted',
        validityViewDetail: 'View Details',
        expiredEnableNotAllowed: 'Expired express surcharge cannot be enabled. Please adjust the validity period first.'
      },
      detail: {
        createTitle: 'New Express Surcharge',
        editTitle: 'Edit Express Surcharge',
        viewTitle: 'Express Surcharge Detail',
        copyTitle: 'Copy Express Surcharge',
        copyModeAlert: 'Copy mode: original surcharge data copied. No. will be auto-generated after saving.',
        buttons: {
          back: 'Back',
          save: 'Save',
          edit: 'Edit',
          copy: 'Copy',
          changeHistory: 'Change History'
        }
      }
    },

    lastMile: {
      configName: 'Last Mile Surcharge',
      actions: {
        add: 'New Last Mile Surcharge',
        import: 'Import',
        batchEnable: 'Batch Enable ({count})',
        batchDisable: 'Batch Disable ({count})',
        view: 'Details',
        edit: 'Edit',
        more: 'More',
        copy: 'Copy',
        enable: 'Enable',
        disable: 'Disable',
        delete: 'Delete'
      },
      messages: {
        deleteTitle: 'Confirm Delete',
        deleteContent: 'Are you sure you want to delete this record? This cannot be undone.',
        deleteOkText: 'Confirm Delete',
        disableContent: 'Are you sure you want to disable this record?',
        enableContent: 'Are you sure you want to enable this record?',
        batchEnableTitle: 'Batch Enable',
        batchEnableContent: 'Enable {count} selected record(s)?',
        batchDisableTitle: 'Batch Disable',
        batchDisableContent: 'Disable {count} selected record(s)?',
        enableSuccess: 'Enabled successfully',
        enableFailed: 'Enable failed',
        disableSuccess: 'Disabled successfully',
        disableFailed: 'Disable failed',
        deleteSuccess: 'Deleted successfully',
        deleteFailed: 'Delete failed',
        batchEnableSuccess: 'Successfully enabled {count} records',
        batchEnableFailed: 'Batch enable failed',
        batchDisableSuccess: 'Successfully disabled {count} records',
        batchDisableFailed: 'Batch disable failed',
        dateRangeTo: 'Until {date}',
        dateRangeFrom: 'From {date}'
      },
      columns: {
        pods: 'POD',
        podTerminalIds: 'POD Terminal',
        supplierIds: 'Supplier',
        cargoTypes: 'Cargo Type',
        officeIds: 'Office',
        addressType: 'Address Type',
        priority: 'Priority'
      },
      detail: {
        createTitle: 'New Last Mile Surcharge',
        editTitle: 'Edit Last Mile Surcharge',
        viewTitle: 'Last Mile Surcharge Detail',
        copyTitle: 'Copy Last Mile Surcharge',
        copyModeAlert: 'Copy mode: original surcharge data copied. ID will be auto-generated after saving.',
        basicInfo: 'Basic Information',
        feeNo: 'Surcharge No.',
        pod: 'POD',
        podTerminal: 'POD Terminal',
        supplier: 'Supplier',
        cargoType: 'Cargo Type',
        office: 'Office',
        priority: 'Priority',
        priorityTooltip: 'Higher value = higher priority, default 1',
        validPeriod: 'Validity',
        deliveryRegion: 'Delivery Address Region',
        regionTip1: 'Select delivery region by Country/Province/City/District cascading, exactly matching the delivery address of last-mile rate; multiple delivery addresses can be maintained',
        regionTip2: 'Rules: Country/Province/City support single selection only; District/Detail Address support multiple values (semicolon-separated), empty means match all; if a level has multiple values, sub-levels cannot be filled',
        deliveryAddressLabel: 'Delivery Address {n}',
        noRegionSelected: 'No region selected',
        addressType: 'Address Type',
        warehouseCode: 'Warehouse Code',
        easyWarehouseCode: 'Easy Warehouse Code',
        country: 'Country',
        province: 'Province',
        city: 'City',
        district: 'District',
        postalCode: 'Postal Code',
        detailAddress: 'Detail Address',
        addDeliveryAddress: 'Add Delivery Address',
        feeDetails: 'Fee Details',
        containerTypeSettings: 'Box Type Settings',
        addFeeItem: 'Add Fee Item',
        selectBoxTypeTip: 'Select container types to display:',
        delete: 'Delete',
        yes: 'Yes',
        no: 'No',
        buttons: {
          back: 'Back',
          save: 'Save',
          edit: 'Edit',
          copy: 'Copy'
        },
        placeholders: {
          feeNoGenerated: 'Auto-generated after saving',
          feeNoAuto: 'Auto-generated',
          select: 'Please select',
          enterPriority: 'Enter priority',
          beginDate: 'Start Date',
          endDate: 'End Date',
          selectCountry: 'Select country',
          selectProvince: 'Select province',
          selectCity: 'Select city',
          enterDistrict: 'Enter district',
          enterPostalCode: 'Enter postal code',
          enterDetailAddress: 'Enter detail address and press Enter to confirm',
          selectAmazonWarehouse: 'Select Amazon warehouse',
          selectEasyWarehouse: 'Select Easy warehouse',
          selectFeeItem: 'Select fee name',
          enterUnitPrice: 'Enter unit price',
          enterUnitRate: 'Enter fee (BL)',
          enterRemarks: 'Enter remarks',
          enterInput: 'Enter'
        },
        validation: {
          podRequired: 'Please select POD',
          officeIdsRequired: 'Please select office',
          countryIdRequired: 'Please select country',
          provinceIdRequired: 'Please select province',
          cityIdRequired: 'Please select city'
        },
        tableColumns: {
          feeName: 'Fee Name',
          billingUnit: 'Billing Unit',
          currency: 'Currency',
          unitPrice: 'Unit Price',
          unitRate: 'Fee (BL)',
          paymentType: 'Payment Type',
          remarks: 'Remarks',
          isTotalIncluded: 'Total Included',
          isCountTotal: 'Count Into Total',
          actions: 'Actions'
        },
        messages: {
          pleaseFillRequired: 'Please complete all required fields',
          feeNameRequired: 'Row {row}: fee name is required',
          billingUnitRequired: 'Row {row}: billing unit is required',
          currencyRequired: 'Row {row}: currency is required',
          isTotalIncludedRequired: 'Row {row}: please select whether total is included',
          isCountTotalRequired: 'Row {row}: please select whether to count into total',
          conflictTitle: 'Data Conflict',
          conflictContent: 'Conflict with surcharges: {feeNos}. Continue saving?',
          confirmOverride: 'Confirm Override',
          cancel: 'Cancel',
          saveSuccess: 'Saved successfully',
          saveFailed: 'Save failed'
        }
      },

      import: {
        title: 'Import Last Mile Surcharge',
        templateSection: 'Template Download',
        templateDesc: 'Please download the standard import template first, fill in data as per the template format, then upload',
        downloadTemplate: 'Last Mile Surcharge Import Template.xlsx',
        uploadSection: 'File Upload',
        dragText: 'Drag file here or click to upload',
        dragHint: 'Supports .xlsx / .xls format, max 5MB',
        remove: 'Remove',
        autoFillTitle: 'Auto-fill Instructions',
        autoFillOffice: 'Office: automatically retrieved from your office upon import',
        autoFillStatus: 'Status: automatically determined by validity period after import (current date ≤ end date → enabled; otherwise → expired)',
        autoFillUnit: 'Billing Unit: supports Container, BL, Day, Time, Weight(KGS), CBM, Ton(TEN), Revenue Ton(RT)',
        autoFillBoxPrice: 'Container Price: when unit is "Container", at least one container type price is required',
        autoFillUnitPrice: 'Unit Rate: required when unit is not "Container"',
        autoFillInTotal: 'Count Into Total: defaults to "No"',
        autoFillIncluded: 'Total Included: defaults to "No"',
        cancel: 'Cancel',
        startValidate: 'Start Validation',
        validating: 'Validating...',
        fileSizeError: 'File size cannot exceed 5MB',
        fileTypeError: 'Please upload an Excel file (.xlsx or .xls)',
        uploadSuccess: 'Upload successful, parse task submitted',
        uploadFailed: 'Upload failed, please retry',
        downloadSuccess: 'Template downloaded successfully',
        downloadFailed: 'Failed to download template'
      }
    }
  }
}
